import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCoin = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_15627_1574)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M1.18078 13.8514C-0.393594 12.277 -0.393594 9.71953 1.18078 8.14516L8.14516 1.18078C9.71953 -0.393594 12.277 -0.393594 13.8514 1.18078L20.8158 8.14516C22.3902 9.71953 22.3902 12.277 20.8158 13.8514L13.8514 20.8158C12.277 22.3902 9.71953 22.3902 8.14516 20.8158L1.18078 13.8514Z",
				fill: "#FFCE80"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.58078 4.70641C10.5227 3.76453 12.0489 3.76453 12.9908 4.70641L17.8652 9.58078C18.807 10.5227 18.807 12.0489 17.8652 12.9908L12.9908 17.8652C12.0489 18.807 10.5227 18.807 9.58078 17.8652L4.70641 12.9908C3.76453 12.0489 3.76453 10.5227 4.70641 9.58078L9.58078 4.70641Z",
				fill: "#FFCE80",
				stroke: "#F8AB30",
				strokeWidth: .825
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7 10.8516C7 10.495 7.07715 10.1778 7.23145 9.90007C7.38575 9.61891 7.60005 9.40118 7.87436 9.24688C8.15209 9.08915 8.46583 9.01029 8.81558 9.01029C9.24418 9.01029 9.61107 9.12344 9.91624 9.34974C10.2214 9.57605 10.4254 9.88464 10.5283 10.2755H9.56135C9.48935 10.1247 9.38648 10.0098 9.25276 9.93093C9.12246 9.85207 8.9733 9.81264 8.80529 9.81264C8.53441 9.81264 8.31496 9.90693 8.14695 10.0955C7.97894 10.2841 7.89493 10.5361 7.89493 10.8516C7.89493 11.167 7.97894 11.4191 8.14695 11.6076C8.31496 11.7962 8.53441 11.8905 8.80529 11.8905C8.9733 11.8905 9.12246 11.8511 9.25276 11.7722C9.38648 11.6934 9.48935 11.5785 9.56135 11.4276H10.5283C10.4254 11.8185 10.2214 12.1271 9.91624 12.3534C9.61107 12.5763 9.24418 12.6877 8.81558 12.6877C8.46583 12.6877 8.15209 12.6106 7.87436 12.4563C7.60005 12.2986 7.38575 12.0808 7.23145 11.8031C7.07715 11.5253 7 11.2082 7 10.8516Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.6385 13.2792L13.1756 12.6569C13.0385 12.6843 12.9047 12.698 12.7745 12.698C12.435 12.698 12.123 12.6192 11.8384 12.4614C11.5572 12.3037 11.3326 12.0843 11.1646 11.8031C11 11.5185 10.9177 11.1996 10.9177 10.8464C10.9177 10.4933 11 10.1761 11.1646 9.89493C11.3326 9.61376 11.5572 9.39432 11.8384 9.23659C12.123 9.07886 12.435 9 12.7745 9C13.1139 9 13.4242 9.07886 13.7054 9.23659C13.99 9.39432 14.2129 9.61376 14.374 9.89493C14.5386 10.1761 14.6209 10.4933 14.6209 10.8464C14.6209 11.155 14.5575 11.4379 14.4306 11.6951C14.3072 11.9488 14.134 12.1597 13.9111 12.3277L14.7032 13.2792H13.6385ZM11.8178 10.8464C11.8178 11.1653 11.9035 11.4208 12.075 11.6128C12.2498 11.8014 12.483 11.8957 12.7745 11.8957C13.0625 11.8957 13.2922 11.7997 13.4637 11.6076C13.6385 11.4156 13.726 11.1619 13.726 10.8464C13.726 10.5276 13.6385 10.2738 13.4637 10.0852C13.2922 9.89322 13.0625 9.79721 12.7745 9.79721C12.483 9.79721 12.2498 9.8915 12.075 10.0801C11.9035 10.2687 11.8178 10.5241 11.8178 10.8464Z",
				fill: "black"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_15627_1574",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 22,
			height: 22,
			fill: "white"
		})
	}) })]
});
export default SvgCoin;
